export default {
    users: [],
    services: []
};
